import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { getIconForFileProvider as getAddProviderIconCSS } from 'owa-fileprovider-icon';
import loc from 'owa-localize';
import * as React from 'react';
import { showFileProviderInlineView } from '../actions/internalActions';
import { getFilePickerStore } from '../store/filePickerStore';
import { AddAFileProvider } from './AddFileProviderView.locstring.json';
import FileProviderView from './FileProviderView';

import styles from './AddFileProviderView.scss';

export default observer(function AddFileProviderView() {
    return (
        <>
            <FileProviderView
                name={loc(AddAFileProvider)}
                icon={getAddProviderIconCSS(ControlIcons.Add, styles.icon)}
                onClick={onAddProviderClicked}
                ariaLabel={loc(AddAFileProvider)}
                isSelected={getFilePickerStore().viewState.showFileProviderInlineView}
            />
        </>
    );
});

function onAddProviderClicked() {
    showFileProviderInlineView(true);
}
